import { Component, input, signal, computed, inject } from "@angular/core";
import { CommonModule } from "@angular/common";
import { IEnergyCalculationReport } from "src/models/energy-estimate/energy-calculation-report.model";
import { EvGridTableModule, ITableLayoutModel, SortUtil, ITableHeader, BaseListComponent } from "ev-grid-table";
import { DefaultConverterPipe } from "src/app/shared/pipes/defaultconverter.pipe";
import { environment } from "src/environments/environment";
import { EnergyDataService } from "src/services/energy-data.service";
import { EvLogoLoaderComponent } from "src/app/shared-components/ev-logo-loader/ev-logo-loader.component";

@Component({
    selector: "energy-calculation-reports",
    templateUrl: "./energy-calculation-reports.component.html",
    styleUrl: "./energy-calculation-reports.component.scss",
    imports: [EvGridTableModule, DefaultConverterPipe, CommonModule, EvLogoLoaderComponent],
})
export class EnergyCalculationReportsComponent extends BaseListComponent<IEnergyCalculationReport> {
    reports = input.required<IEnergyCalculationReport[]>();
    hasGreenHomeRole = input<boolean>(false);

    private energyDataService = inject(EnergyDataService);
    greenEnergyIconUrl = `${environment.cdnUrl}/energyresources/icon-gronnbolig.svg`;
    downloadingReport: boolean = false;

    originalData = computed(() => this.reports() || []);

    constructor() {
        super();
    }

    openReport(id: string) {
        this.downloadingReport = true;

        this.energyDataService.getEnergyEstimateReport(id).subscribe((report) => {
            this.downloadingReport = false;
            this.createAndShowPdfFile(report);
        });
    }

    private createAndShowPdfFile(data: any) {
        if (!data) {
            return;
        }

        const binaryString = window.atob(data.data);
        const bytes = new Uint8Array(binaryString.length);
        const uInt8Array = bytes.map((_, i) => binaryString.charCodeAt(i));
        const blob = new Blob([uInt8Array], { type: "application/pdf" });
        const newWindow = window.open("", "_blank");
        let url: string = "";

        if (window.webkitURL != null) {
            url = window.webkitURL.createObjectURL(blob);
        } else {
            url = URL.createObjectURL(blob);
        }

        newWindow.location.href = url;
    }

    protected createDisplayTemplate(): ITableLayoutModel {
        return {
            breakPoints: [
                {
                    gridAreas:
                        '"createdDate pdfReportID" "energyCalculationReportID energyCalculationReportID" "estimatedAnnualEnergyUsePre estimatedAnnualEnergyUsePre" "estimatedAnnualEnergyUsePost estimatedAnnualEnergyUsePost"',
                    gridColumns: "100px 1fr",
                    maxWidth: 525,
                },
                {
                    gridAreas:
                        '"createdDate energyCalculationReportID pdfReportID" "estimatedAnnualEnergyUsePre estimatedAnnualEnergyUsePre estimatedAnnualEnergyUsePre" "estimatedAnnualEnergyUsePost estimatedAnnualEnergyUsePost estimatedAnnualEnergyUsePost"',
                    gridColumns: "100px 100px 1fr",
                    maxWidth: 975,
                },
                {
                    gridAreas: '"createdDate energyCalculationReportID estimatedAnnualEnergyUsePre estimatedAnnualEnergyUsePost pdfReportID"',
                    gridColumns: "100px 100px 200px 200px 1fr",
                },
            ],
        };
    }

    protected createHeaders(): ITableHeader[] {
        return [
            {
                name: "Dato",
                prop: "createdDate",
                desc: true,
                type: "date",
                isSortable: true,
            },
            {
                name: "Rapport Id",
                prop: "energyCalculationReportID",
                desc: true,
                type: "number",
                isSortable: true,
            },
            {
                name: "Energibruk Pr m² Før tiltak",
                prop: "estimatedAnnualEnergyUsePre",
                desc: true,
                type: "number",
                textAlignment: "right",
                isSortable: true,
            },
            {
                name: "Energibruk Pr m² Etter tiltak",
                prop: "estimatedAnnualEnergyUsePost",
                desc: true,
                type: "number",
                textAlignment: "right",
                isSortable: true,
            },
            {
                name: "",
                prop: "pdfReportID",
                type: "text",
                isSortable: false,
                desc: true,
            },
        ];
    }
}
